import React from 'react';
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import {Box} from "@mui/material";
import {IColumnItem} from "@ui/tableCustom/types/columns";

const sx = {
    orders: {
        display: 'grid',
        minWidth: '20px',
        '& .MuiSvgIcon-root': {
            width: '15px',
            height: '13px'
        }
    }
}

interface IProps<T> {
    order: keyof T | false,
    setOrder: (order: keyof T) => void
    direction: string,
    setDirection: (order: string) => void,
    column: IColumnItem<T>,

}

function SetOrderButton<T>({
                               order,
                               direction,
                               setDirection,
                               setOrder,
                               column
                           }: IProps<T>) {
    return (
        <Box sx={sx.orders}>
            <KeyboardArrowUpOutlinedIcon
                fontSize={'small'}
                color={direction === 'ASC' && order === column.id ? 'primary' : 'secondary'}
                onClick={() => {
                    setDirection('ASC')
                    setOrder(column.id as keyof T)
                }}
            />

            <KeyboardArrowDownOutlinedIcon
                onClick={() => {
                    setDirection('DESC')
                    setOrder(column.id as keyof T)
                }}
                fontSize={'small'}
                color={direction === 'DESC' && order === column.id ? 'primary' : 'secondary'}
            />
        </Box>
    );
};

export default SetOrderButton;